import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";
import { TYPE_LABELS, TYPE_COLORS } from "../web/constants";

const transition =
    "transform 220ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 220ms cubic-bezier(0.4, 0, 0.2, 1)";

export default function MobileDashboardTypeBreakdown({ typeBreakdown, leaveStats }) {
    return (
        <Card
            sx={{
                borderRadius: "16px",
                boxShadow:
                    "0 4px 20px rgba(255, 144, 21, 0.05), 0 1px 8px rgba(20, 24, 44, 0.05)",
                border: "1px solid rgba(255, 255, 255, 0.55)",
                background:
                    "linear-gradient(160deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,0.60) 100%)",
                backdropFilter: "blur(16px) saturate(1.4)",
                WebkitBackdropFilter: "blur(16px) saturate(1.4)",
                position: "relative",
                overflow: "hidden",
                transition,
                "&:active": {
                    transform: "scale(0.97)",
                },
            }}
        >
            {/* Blue accent top bar */}
            <Box
                sx={{
                    height: 4,
                    background:
                        "linear-gradient(90deg, #1d4ed8, rgba(255,255,255,0.85), #0ea5e9)",
                }}
            />

            <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 700,
                        fontSize: "0.85rem",
                        letterSpacing: "-0.01em",
                        color: "rgba(20, 24, 44, 0.88)",
                    }}
                >
                    Répartition par type
                </Typography>

                <Divider
                    sx={{
                        my: 1,
                        borderColor: "rgba(148, 163, 184, 0.18)",
                    }}
                />

                <Stack spacing={1}>
                    {typeBreakdown.length ? (
                        typeBreakdown.map(([type, count]) => {
                            const barColor =
                                TYPE_COLORS[type] || TYPE_COLORS.OTHER || "#94a3b8";
                            return (
                                <Box
                                    key={type}
                                    sx={{
                                        px: 1.25,
                                        py: 0.75,
                                        borderRadius: "10px",
                                        transition:
                                            "background 200ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        "&:active": {
                                            background: `${barColor}14`,
                                            boxShadow: `0 2px 8px ${barColor}18`,
                                        },
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "0.78rem",
                                                color: "rgba(20, 24, 44, 0.75)",
                                                letterSpacing: "0.01em",
                                            }}
                                        >
                                            {TYPE_LABELS[type] || type}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: "0.78rem",
                                                color: barColor,
                                            }}
                                        >
                                            {count}
                                        </Typography>
                                    </Stack>
                                    <LinearProgress
                                        value={
                                            leaveStats.total
                                                ? (count / leaveStats.total) * 100
                                                : 0
                                        }
                                        variant="determinate"
                                        sx={{
                                            mt: 0.75,
                                            height: 5,
                                            borderRadius: 999,
                                            backgroundColor: "rgba(148, 163, 184, 0.12)",
                                            "& .MuiLinearProgress-bar": {
                                                borderRadius: 999,
                                                background: `linear-gradient(90deg, ${barColor}, ${barColor}cc)`,
                                                transition:
                                                    "transform 600ms cubic-bezier(0.4, 0, 0.2, 1)",
                                            },
                                        }}
                                    />
                                </Box>
                            );
                        })
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                color: "rgba(100, 116, 139, 0.7)",
                                fontStyle: "italic",
                                fontSize: "0.78rem",
                                py: 1.5,
                                textAlign: "center",
                            }}
                        >
                            Aucune donnée disponible.
                        </Typography>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
}
